export const INVOICE_BANK_ADENDA =
  'Cuenta corriente en $ BROU 001904110-00001 y $ BBVA 25190521 Oscar Uccellini';

const BANK_ADENDA_MARKER = '001904110-00001';

export function buildInvoiceAdendaText(parts = []) {
  const filtered = parts
    .map((part) => String(part || '').trim())
    .filter(Boolean);

  const joined = filtered.join(' | ');
  if (joined.includes(BANK_ADENDA_MARKER)) {
    return joined;
  }

  return joined
    ? `${joined} | ${INVOICE_BANK_ADENDA}`
    : INVOICE_BANK_ADENDA;
}
